// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"_5npPeesLBfo8BAOMAgh7r0"};